// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__vrv_w","gfeWrapper":"CalendarEvent_gfeWrapper__z1JSs"};